/**
 * Document status enum
 */
export enum DocumentStatus {
  PENDING_UPLOAD = 'pending_upload',
  UPLOADED = 'uploaded',
  VERIFIED = 'verified',
  REJECTED = 'rejected',
  REPLACED = 'replaced'
}

/**
 * Document entity type enum
 */
export enum DocumentEntityType {
  TRUST_ACCOUNT = 'trust_account',
  DEAL = 'deal',
  TRANSACTION = 'transaction',
  FIRM = 'firm',
  USER = 'user'
}

/**
 * Document type enum - categorizes documents by their purpose
 */
export enum DocumentType {
  LAND_OWNERSHIP_VERIFICATION = 'land_ownership_verification',
  TRUSTEE_INSTRUCTIONS = 'trustee_instructions',
  TRANSACTION_LEGAL_DOCUMENT = 'transaction_legal_document',
  ADDITIONAL_DOCUMENT = 'additional_document',
  BUYER_REGISTRATION_FORM = 'buyer_registration_form',
  SIGNED_SALE_AGREEMENT = 'signed_sale_agreement',
  SALE_AGREEMENT = 'sale_agreement',
  OPTION_AGREEMENT = 'option_agreement',
  ASSIGNMENT_AGREEMENT = 'assignment_agreement',
  INCORPORATION_CERTIFICATE = 'incorporation_certificate',
  AUTHORIZED_SIGNATORIES_PROTOCOL = 'authorized_signatories_protocol',
  COMPANY_REGISTRATION_EXTRACT = 'company_registration_extract',
  NATIONAL_ID_DOCUMENT = 'national_id_document',
  PASSPORT_DOCUMENT = 'passport_document',
  FATCA_CRS_DECLARATION = 'fatca_crs_declaration',
  FATCA_CRS_SUPPLEMENTARY_DECLARATION = 'fatca_crs_supplementary_declaration',
  BANK_ACCOUNT_CONFIRMATION = 'bank_account_confirmation',
  PAYMENT_DEMAND_DOCUMENT = 'payment_demand_document',
  PAYMENT_VOUCHER = 'payment_voucher',
  UNKNOWN = 'unknown'
}

/**
 * Document context enum - tracks where/why the document is used
 */
export enum DocumentContext {
  COMPLIANCE = 'compliance',
  KYC = 'kyc',
  PURCHASE_DOCUMENTS = 'purchase_documents',
  TRUST_DETAILS = 'trust_details',
  PAYOUTS = 'payouts'
}

/**
 * Document audit action enum
 */
export enum DocumentAuditAction {
  PRESIGNED = 'presigned',
  UPLOADED = 'uploaded',
  VERIFIED = 'verified',
  REJECTED = 'rejected',
  DELETED = 'deleted',
  DOWNLOADED = 'downloaded'
}

/**
 * Processing status for AI document workflows (classification + extraction).
 * Stored on the document so the FE can poll a single endpoint.
 */
export enum DocumentProcessingStatus {
  /** No AI processing active or requested */
  IDLE = 'idle',
  /** Enqueued — waiting for the worker to pick it up */
  PENDING = 'pending',
  /** Processing in progress */
  PROCESSING = 'processing',
  /** AI processing completed successfully */
  COMPLETED = 'completed',
  /** AI processing failed */
  FAILED = 'failed',
  /**
   * Worker evaluated the document and decided no processing was needed.
   * Accompanies a skipReason explaining why (no schema, context mismatch, all fields populated).
   */
  SKIPPED = 'skipped'
}

/**
 * Processor type enum - identifies pipeline stage
 */
export enum DocumentProcessorType {
  CLASSIFICATION = 'classification',
  EXTRACTION = 'extraction'
}

/**
 * Processor status enum - tracks stage-level progress
 */
export enum DocumentProcessorStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
  SKIPPED = 'skipped'
}

export enum DocumentJobKind {
  PROCESS = 'process',
  GENERATE = 'generate'
}

export enum DocumentGenerator {
  FATCA_CRS_DECLARATION = 'fatca_crs_declaration'
}
